import React from 'react';
import PropTypes from 'prop-types';

const YesNoToggle = ({ value, onChange, disabled = false }) => {
  const normalizedValue = String(value || 'no').toLowerCase();
  const isYes = normalizedValue === 'yes';
  const isNo = normalizedValue === 'no';

  const handleSelect = (val) => {
    if (disabled) return;
    // Call onChange with the original casing format expected by the form
    const originalCasing = String(value).charAt(0) === 'Y' 
      ? val.charAt(0).toUpperCase() + val.slice(1) 
      : val;
    onChange({ target: { value: originalCasing } });
  };

  return (
    <div 
      className="yes-no-toggle-container"
      style={{
        display: 'inline-flex',
        background: '#f1f5f9',
        padding: '4px',
        borderRadius: '8px',
        border: '1px solid #cbd5e1',
        pointerEvents: disabled ? 'none' : 'auto',
        opacity: disabled ? 0.65 : 1,
      }}
    >
      <button
        type="button"
        onClick={() => handleSelect('yes')}
        style={{
          background: isYes ? '#2563eb' : 'transparent',
          color: isYes ? '#ffffff' : '#475569',
          border: 'none',
          borderRadius: '6px',
          padding: '6px 16px',
          fontWeight: 600,
          fontSize: '14px',
          transition: 'all 0.2s ease',
          boxShadow: isYes ? '0 1px 3px rgba(37, 99, 235, 0.3)' : 'none',
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
      >
        Yes
      </button>
      <button
        type="button"
        onClick={() => handleSelect('no')}
        style={{
          background: isNo ? '#2563eb' : 'transparent',
          color: isNo ? '#ffffff' : '#475569',
          border: 'none',
          borderRadius: '6px',
          padding: '6px 16px',
          fontWeight: 600,
          fontSize: '14px',
          transition: 'all 0.2s ease',
          boxShadow: isNo ? '0 1px 3px rgba(37, 99, 235, 0.3)' : 'none',
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
      >
        No
      </button>
    </div>
  );
};

YesNoToggle.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default YesNoToggle;
